import * as React from 'react';
import getHighlightedTextForSuggestion from '../../../utils/getHighlightedTextForSuggestion';
import highlightDisplayText from '../../../utils/highlightDisplayText';
import { observer } from 'mobx-react-lite';
import { SMALL_SUGGESTION_HEIGHT } from '../../../searchConstants';
import { SubstrateSearchSuggestionTextSegment } from 'owa-search-service';

const styles = require('./TextSegment.scss');

export interface TextSegmentProps {
    segment: SubstrateSearchSuggestionTextSegment;
}

export const TextSegment = observer(function TextSegment(props: TextSegmentProps) {
    const { segment } = props;

    const hitHighlightedDisplayText = highlightDisplayText(segment.DisplayText);

    const style: React.CSSProperties = {
        lineHeight: `${SMALL_SUGGESTION_HEIGHT}px`,
    };

    return (
        <div className={styles.container} style={style}>
            {getHighlightedTextForSuggestion(hitHighlightedDisplayText)}
        </div>
    );
});
